// Safely extract a human-readable message from an axios/FastAPI error.
// FastAPI validation errors (422) return `detail` as an ARRAY of objects
// ({type, loc, msg, input, ctx}); passing such an object to a toast/JSX child
// crashes React (error #31 → blank page). Always coerce to a string here.
export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((d) => {
        if (typeof d === 'string') return d;
        if (d && typeof d === 'object') {
          // Include the field name (last part of loc) for clarity when available
          const field = Array.isArray(d.loc) ? d.loc[d.loc.length - 1] : null;
          const msg = d.msg || 'Invalid value';
          return field && field !== 'body' ? `${field}: ${msg}` : msg;
        }
        return null;
      })
      .filter(Boolean);
    if (messages.length) return messages.join('; ');
  }

  if (detail && typeof detail === 'object') {
    return detail.msg || fallback;
  }

  return error?.message || fallback;
};
